import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const { googleExchange } = useAuth();
  const nav = useNavigate();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      setError("Missing session");
      return;
    }

    (async () => {
      try {
        await googleExchange(sessionId);
        // Remove the hash and go to dashboard
        window.history.replaceState(null, "", "/dashboard");
        toast.success("Signed in with Google");
        nav("/dashboard", { replace: true });
      } catch (e) {
        console.error(e);
        setError("Google sign-in failed");
        setTimeout(() => nav("/login", { replace: true }), 1500);
      }
    })();
  }, [googleExchange, nav]);

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="text-center">
        <div className="progress-track w-48 mx-auto mb-6">
          <div className="progress-fill"></div>
        </div>
        <div className="overline text-[--muted]" data-testid="auth-callback-status">
          {error ? error : "Finalizing sign-in…"}
        </div>
      </div>
    </div>
  );
}
